import { ThemeProviderContext } from '@/app/ThemeProvider.tsx';
import { useContext } from 'react';

/**
 * 시스템 테마를 구독하는 hook을 생성합니다.
 * @returns ThemeProviderContext
 * @author Olive
 */
const useTheme = () => {
  const context = useContext(ThemeProviderContext);

  if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider');

  return context;
};

export default useTheme;
